/**
 * Can be used like nameOf<IInterface>().PropertyName
 * @returns The string name of the property of a class or interface.
 */
export function nameOf<T>() {
    return _name_proxy as unknown as NamedPropsOf<{ [P in keyof T]: P }>;
}
const _name_proxy = new Proxy({}, { get(_, key) { return key; } });

/** Keeps named properties of T, removing index props like `[k:string]: T` */
export type NamedPropsOf<T, P=PropertyKey> = {
    [K in keyof T as (P extends K ? never : (K extends P ? K : never))]: T[K]
};